import { Grid, Typography } from '@mui/material';
import {
  CustomTextAreaNoForm,
  CustomTextFieldNoForm,
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import {
  // AlertSeverityEnum,
  Contrato,
} from '@/shared/interfaces';
// import { useUiStore } from '@/store/ui';
// import { useRef, useState } from 'react';
import { gridSizeMdLg12 } from '@/shared';
import dayjs from 'dayjs';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  contract?: Contrato;
}


export const SendByMotivoRechazoFromOT = {
  toPyl: "ENVIAR A RECOORDINAR",
  toVentas: "ENVIAR A GESTIÓN ASESOR"
}

const ModalVerHistorialObservaciones: React.FC<ConfirmRejectOTDialogProps> = ({
  open,
  setOpen,
  contract,
}) => {
  ///* global state
  // const setAlert = useUiStore(s => s.setAlert);
  // const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
  // const flatpickrRef = useRef<Flatpickr>(null);
  // const [fechasReporte, setFechasReporte] = useState<Date[]>([]);



  return (
    <ScrollableDialogProps
      open={open}
      title="Historial de Observaciones"
      cancelTextBtn="Cerrar"
      showConfirmBtn={false}
      // confirmTextBtn="Generar"
      // confirmVariantBtn="outlined"
      // actions
      onClose={() => {
        setOpen(false);
      }}
      // onConfirm={() => {
      //   onGenerateExcel()
      // }}
      // content
      minWidth="42%"
      contentNode={
        <>
          <Grid container spacing={3}>
            {/* -------- text -------- */}
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Se presentan a continuación las observaciones realizadas históricamente.
              </Typography>
            </Grid>

            {/*----------- Observacion general de asesor ------------*/}

            <CustomTextAreaNoForm
              disabled={true}
              label={`Observación Asesor`}
              defaultValue={contract?.observaciones?.observacion_asesor ?? 'N/A'}
              value={contract?.observaciones?.observacion_asesor ?? 'N/A'}
              size={gridSizeMdLg12}
            />

            {/* -------- Observaciones -------- */}
            {
              contract?.observaciones_contrato?.contenido?.map((item, index) => <>
                <Grid key={`obs-historial-${index}`} container item xs={12}>
                  <Typography variant="h6"
                    pt="0"
                    // pb="18px"
                    pl="0"
                    mt="0"
                  >Corrección {index + 1}</Typography>
                  <Grid container item>
                    <TabTextLabel
                      text="Motivos"
                      pt="0"
                      pb="18px"
                      pl="0"
                      mt="0"
                    />
                    <CustomTextAreaNoForm
                      disabled={true}
                      label={``}
                      value={item?.motivos?.flatMap((x) => `${x}\n`).join("")}
                      defaultValue={"contentText"}
                      size={gridSizeMdLg12}
                      rows={3}
                    />
                  </Grid>
                  <Grid container item {...gridSizeMdLg12} sx={{ marginY: "20px" }}>
                    <TabTextLabel
                      text="Fecha de Observación"
                      pt="0"
                      pb="18px"
                      pl="0"
                      mt="0"
                    />
                    <CustomTextFieldNoForm
                      label=''
                      value={dayjs(item?.fecha)?.format("LLL")?.toString()}
                    />
                  </Grid>
                  <Grid container item {...gridSizeMdLg12}>
                    {
                      item?.observaciones_ventas || item?.observaciones_tecnico ? <>
                        {
                          item?.observaciones_ventas ? <>
                            <Grid container item {...gridSizeMdLg12} sx={{ marginY: "10px" }}>
                              <TabTextLabel
                                text="Observaciones Ventas"
                                pt="0"
                                pb="18px"
                                pl="0"
                                mt="0"
                              />
                              <CustomTextAreaNoForm
                                disabled={true}
                                label={``}
                                value={item?.observaciones_ventas!}
                                defaultValue={""}
                                size={gridSizeMdLg12}
                                rows={4}
                              />
                            </Grid>
                          </>
                            : null
                        }
                        {
                          item?.observaciones_tecnico ? <>
                            <Grid container item {...gridSizeMdLg12} sx={{ marginY: "10px" }}>
                              <TabTextLabel
                                text="Observaciones Técnico"
                                pt="0"
                                pb="18px"
                                pl="0"
                                mt="0"
                              />
                              <CustomTextAreaNoForm
                                disabled={true}
                                label={``}
                                value={item?.observaciones_tecnico || item?.observaciones || ""}
                                defaultValue={""}
                                size={gridSizeMdLg12}
                                rows={4}
                              />
                            </Grid>
                          </>
                            : null
                        }

                      </>
                        : <>
                          <TabTextLabel
                            text="Observaciones"
                            pt="0"
                            pb="18px"
                            pl="0"
                            mt="0"
                          />
                          <CustomTextAreaNoForm
                            disabled={true}
                            label={``}
                            value={item?.observaciones!}
                            defaultValue={""}
                            size={gridSizeMdLg12}
                            rows={4}
                          />
                        </>
                    }

                  </Grid>
                  <hr style={{ border: "1px solid #c1c1c1", margin: "20px 0", width: "100%" }} />
                </Grid>
              </>
              )
            }



          </Grid>
        </>
      }
    />
  );
};

export default ModalVerHistorialObservaciones;
